import { render, staticRenderFns } from "./newTransfer.vue?vue&type=template&id=721fdf60&lang=pug&"
import script from "./newTransfer.vue?vue&type=script&lang=js&"
export * from "./newTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports